import { render, staticRenderFns } from "./not-assigned.vue?vue&type=template&id=4f01d5f1&scoped=true"
import script from "./not-assigned.vue?vue&type=script&lang=js"
export * from "./not-assigned.vue?vue&type=script&lang=js"
import style0 from "./not-assigned.vue?vue&type=style&index=0&id=4f01d5f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f01d5f1",
  null
  
)

export default component.exports